module.exports = __webpack_public_path__ + "img/LogoDashboard-16.5b0ec5d4.svg";